import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Apirequests } from '../../utils/ApiRequests';
import { ErrorTost, SuccessTost } from '../../utils/ToastHelper';
import SpinningLogo from '../../components/Spinner';
import CustomPageHeader from '../../components/CustomPageHeader';
import { downloadExcel } from '../../utils/DownloadXls';
import CommonLeadsTable from './CommonLeadsTable';
import CustomOffCanvas from '../../components/CustomOffCanvas';
import AddCommonLead from './AddCommonLead';

function EngBlsPaid() {

    const [isOffCanvasOpen, setIsOffCanvasOpen] = useState({ state: false, name: "" });
    const [leads, setLeads] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState({ state: false, name: "" });
    const [currentPage, setCurrentPage] = useState(1);
    const [refresh, setRefresh] = useState(false);
    const [currentLead, setCurrentLead] = useState(null);
    const [deleteId, setdeleteId] = useState(null)

    const token = localStorage.getItem("token");

    const totalItems = leads?.length; // Total number of items
    const itemsPerPage = 20;

    const currentData = leads?.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const navigate = useNavigate();

    const handleRefresh = () => setRefresh(!refresh);

    const handleSearch = async () => {
        if (!searchTerm) {
            return ErrorTost("Enter a key to serach")
        }

        if (currentPage !== 1) {
            setCurrentPage(1)
        }

        await getLeads(searchTerm)
    };


    const getLeads = async () => {
        setLoading({ state: true, name: "fetchleads" });
        try {
            const res = await Apirequests(
                `leads/get-leads-new?q=${searchTerm}`,
                "GET",
                {},
                {
                    Authorization: `Bearer ${token}`,
                    lead_type: "blslead"
                }
            );
            //   console.log(res,'course get res')
            if (res?.success) {
                setLeads(res.data);
            }
        } catch (error) {
            console.log(error, "leads res error.");
        }
        setLoading({ state: false, name: "" });
    };

    const deleteLead = async (id) => {
        setdeleteId(id);
        setLoading({ state: true, name: 'deletelead' })
        try {
            const deleteRes = await Apirequests(
                `leads/delete-lead/${id}`,
                "DELETE",
                { lead_type: "blslead" },
                {
                    Authorization: `Bearer ${token}`,
                }
            );
            // console.log(deleteRes,'delete lead');
            setRefresh(!refresh);
            if (deleteRes?.success) {
                SuccessTost(deleteRes?.message);
            } else {
                ErrorTost(deleteRes?.message);
            }
        } catch (error) {
            console.log(error, "delete course error");
            ErrorTost("Something went wrong, please try again later.")
        }
        setdeleteId(null);
        setLoading({ state: false, name: "" })
    };


    useEffect(() => {
        getLeads();
    }, [refresh, token]);


    if (loading.state && loading.name === "fetchleads") {
        return <div className='h-screen w-full flex items-center justify-center bg-[rgba(255,255,255,0.5)]'>
            <SpinningLogo />
        </div>
    }

    return (
        <div>

            <CustomPageHeader
                title={"Bls Eng Paid Leads"}
                text={searchTerm}
                setText={setSearchTerm}
                handleSearch={handleSearch}
                onClick={() => setIsOffCanvasOpen({ state: true, name: "addblsengpaidlead" })}
                btnText={"Add Lead"}
                handleBackClick={() => navigate("/")}
                handleRefresh={handleRefresh}
                handleDownload={() => downloadExcel(leads, 'addblsengpaidlead')}
            />
            <CommonLeadsTable
                leads={currentData}
                loading={loading}
                handleDelete={deleteLead}
                currentPage={currentPage}
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
                handlePageChange={handlePageChange}
                deleteId={deleteId}
            />

            <CustomOffCanvas
                open={isOffCanvasOpen.state && isOffCanvasOpen?.name === "addblsengpaidlead"}
                close={() => setIsOffCanvasOpen({ state: false, name: "" })}
                content={
                    <AddCommonLead
                        close={() => setIsOffCanvasOpen({ state: false, name: "" })}
                        setRefresh={setRefresh}
                        title={"Add BLS English(Paid) Lead"}
                        leadUrl={"leads/submit-blslead"}
                    />
                }
            />
        </div>
    )
}

export default EngBlsPaid